import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d0c83f1c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d0c83f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c83f1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0c83f1c')) {
      api.createRecord('d0c83f1c', component.options)
    } else {
      api.reload('d0c83f1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d0c83f1c&scoped=true&", function () {
      api.rerender('d0c83f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/setting/index.vue"
export default component.exports